export const GET_COURSES = 'GET_COURSES';
export const GET_COURSE = 'GET_COURSE';
export const ADD_COURSE = 'ADD_COURSE';
export const EDIT_COURSE = 'EDIT_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
